import { getValueFromPartnerCookie } from '@ecomm/shared-cookies'

/**
 * Check for partner cookie
 */
export const isStrategicReferralPartner = () =>
  getValueFromPartnerCookie('partnerGroup') === 'partner-strategic-referral'
